module.exports = "//static.hsappstatic.net/connect-dot-com-ui-components/static-1.428/images/connect-logo-bg-for-homepage-card.png"